<section class="title-bar content-padding first-item">
    <div class="wrapper">
      <h2 class="left">Modifica deluxy.com Vendita #{{ sale?.orderId }}</h2>
      <br class="clear">
    </div>
</section>
<section id="modificaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="deluxyDotComSaleForm" (ngSubmit)="onSubmit()" *ngIf="deluxyDotComSaleForm">

            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>Data consegna</legend>

                    <div class="col-40 grid-element">
                        <label>Data consegna{{ deluxyDotComSaleForm.get("deliveryDate") | required }}</label>
                        <input type="date" formControlName="deliveryDate">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('deliveryDate')" [messages]="formValidationMsgs.deliveryDate">
                        </app-error-html-handler>
                    </div>
                    <br class="clear">
        
                    <div class="col-48 grid-element">
                        <label>FASCIA ORARIA CONSEGNA</label>
                        <div class="time-range">
                            <select formControlName="deliveryTime">
                                <option value="07:00-08:00">07:00-08:00</option>
                                <option value="08:00-09:00">08:00-09:00</option>
                                <option value="09:00-10:00">09:00-10:00</option>
                                <option value="10:00-11:00">10:00-11:00</option>
                                <option value="11:00-12:00">11:00-12:00</option>
                                <option value="12:00-13:00">12:00-13:00</option>
                                <option value="13:00-14:00">13:00-14:00</option>
                                <option value="14:00-15:00">14:00-15:00</option>
                                <option value="15:00-16:00">15:00-16:00</option>
                                <option value="16:00-17:00">16:00-17:00</option>
                                <option value="17:00-18:00">17:00-18:00</option>
                                <option value="18:00-19:00">18:00-19:00</option>
                                <option value="19:00-20:00">19:00-20:00</option>
                                <option value="20:00-21:00">20:00-21:00</option>
                                <option value="21:00-22:00">21:00-22:00</option>
                            </select>
                        </div>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Vendor</label>
                        <select id="selezionePartner" type="text" formControlName="vendor">
                            <option disabled></option>
                            <option *ngFor="let partner of partners" [value]="partner.businessName">{{ partner.businessName }}</option>
                        </select>
                    </div>
                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>DETAGLI DEL DESTINATARIO</legend>

                    <div class="col-48 grid-element">
                        <label>Cognome destinatario{{ deluxyDotComSaleForm.get("lastName") | required }}</label>
                        <input type="text" formControlName="lastName">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('lastName')" [messages]="formValidationMsgs.lastName">
                        </app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Nome destinatario{{ deluxyDotComSaleForm.get("firstName") | required }}</label>
                        <input type="text" formControlName="firstName">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('firstName')" [messages]="formValidationMsgs.firstName">
                        </app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Telefono destinatario</label>
                        <input type="text" placeholder="+449878487878" formControlName="phone">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('phone')" [messages]="formValidationMsgs.phone">
                        </app-error-html-handler>
                    </div>
        
                    <div class="grid-element-full">
                        <label>Indirizzo destinatario{{ deluxyDotComSaleForm.get("address") | required }}
                          <span class="directions" (click)="directions($event)"> <i class="fas fa-directions fa-2x"></i>
                          </span>
                        </label>
                        <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="deluxyDotComSaleForm.get('address')"></app-google-maps-search>
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('address')" [messages]="formValidationMsgs.address">
                        </app-error-html-handler>
                    </div>
                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>MINTTENTE DEL DESTINATARIO</legend>

                    <div class="col-48 grid-element">
                        <label>Cognome mittente</label>
                        <input type="text" formControlName="senderSurname">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Nome mittente</label>
                        <input type="text" formControlName="senderName">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Telefono mittente</label>
                        <input type="text" formControlName="senderPhone">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('senderPhone')" [messages]="formValidationMsgs.senderPhone">
                        </app-error-html-handler>
                    </div>
                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>PRODOTTO</legend>

                    <div class="grid-element-full">
                        <label>Prodotto*</label>
                        <div formArrayName="deliveryProducts">
                            <div class="offer-products" *ngFor="let productForm of deluxyDotComSaleForm.get('deliveryProducts').controls; let i = index">
                                <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
                                    <div style="display: table-cell; width: 19px;">
                                        <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                                    </div>
                                    <div class="product-q" formGroupName="product">
                                        <div class="porduct-qty">
                                            <div class="saifu-input">
                                                <ng-select 
                                                    [items]="products" 
                                                    bindLabel="name" 
                                                    bindValue="name" 
                                                    formControlName="name"
                                                    >
                                                </ng-select>
                                            </div>
                                            <div class="saifu-input">
                                                <input type="text" formControlName="quantity" placeholder="Product quantity">
                                                <input type="hidden" formControlName="sku" placeholder="">
                                                <input type="hidden" formControlName="price" placeholder="">
                                            </div> 
                                        </div>
                                    </div>
                                    <br>
                                </div>
                            </div>
                        </div>
                        <div class="center" style="width: 100%;">
                          <button class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                            Aggiungi prodotto<i class="ml-10 fas fa-plus"></i>
                          </button>
                        </div>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Totale</label>
                        <input type="text" formControlName="total">
                    </div>

                    <div class="col-48 grid-element">
                        <label>COSTO CONSEGNE</label>
                        <input type="text" formControlName="totalShippingAmount">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('totalShippingAmount')" [messages]="formValidationMsgs.totalShippingAmount">
                        </app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>VALORE VENDITE</label>
                        <input type="text" formControlName="totalPrice">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('totalPrice')" [messages]="formValidationMsgs.totalPrice">
                        </app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>PREZZO PUBBLICO</label>
                        <input type="text" formControlName="totalLineItemsPrice">
                        <app-error-html-handler [ctrl]="deluxyDotComSaleForm.get('totalLineItemsPrice')" [messages]="formValidationMsgs.totalLineItemsPrice">
                        </app-error-html-handler>
                    </div>
                    
                    <div class="col-48 grid-element">
                        <label>Stato del pagamento</label>
                        <input type="text" formControlName="paymentStatus">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Stato di completamento</label>
                        <input type="text" formControlName="fullFillmentStatus">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Intercom</label>
                        <input type="text" formControlName="intercom">
                    </div>
        
                    <div class="col-48 grid-element">
                        <label>Metodo di consegna</label>
                        <input type="text" formControlName="deliveryMethod">
                    </div>
        
                    <div class="grid-element-full">
                        <label>Notes</label>
                        <textarea formControlName="notes" rows="5" placeholder=""></textarea>
                    </div>

                    <div class="grid-element-full">
                        <label>PERSONALIZZAZIONE</label>
                        <textarea formControlName="personalizeNotes" rows="5" placeholder=""></textarea>
                    </div>
                </fieldset>
            </div>

            <div class="center mt-20">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit($event.target)" [disabled] ="!deluxyDotComSaleForm?.valid">
                    Salva Vendita<i class="ml-10 far fa-save"></i>
                </button>
            </div>

            <div class="error-box" style="margin-top: 15px;" *ngIf="getErrorMessages().length > 0">
                <fieldset>
                  <legend>CAMPI OBBLIGATORI:</legend>
                  <div>
                    <!-- {{ getErrorMessages() | json }} -->
                    <ul class="error-list">
                      <li *ngFor="let error of getErrorMessages()">
                        {{ translateErrorMessage(error) }}
                      </li>
                    </ul>
                  </div>
                </fieldset>
            </div>

        </form>
    </div>
</section>